import {PrintWindow} from "@/addons/PrintWindow";
import {FacturaReport} from "@/models/FacturaReport";
import {ClienteReport} from "@/models/ClienteReport";
import {Factura} from "@/addons/Factura";

export class PrintOtroIngreso extends PrintWindow {
    public imprimir(fac: any,duplicado=false) : void {
        const factura = new FacturaReport();
        factura.leyenda = fac.cabecera.leyenda;
        factura.glosa = fac.cabecera.glosa;
        factura.total = fac.cabecera.total;
        factura.estado = fac.cabecera.estado;
        factura.categoria = fac.cliente.categoria !==null ? fac.cliente.categoria: '';
        factura.cuf = fac.cabecera.cuf;
        factura.fecha_hora_pago = fac.cabecera.fecha_hora_pago;
        factura.planilla_rucnit = fac.cabecera.planilla_rucnit;
        factura.nroFactura = fac.cabecera.nroFactura;
        factura.fecha = fac.cabecera.fecha.substring(0, 10);
        factura.detalle = fac.detalles;
        factura.tarifa = "OTROS INGRESOS";

        const cliente = new ClienteReport();
        cliente.razon_social = fac.cliente.razon_social;
        cliente.direccion = fac.cliente.direccion;
        cliente.ci = fac.cliente.ci;
        cliente.cuenta = fac.cliente.cuenta;
        cliente.catastro = fac.cliente.catastro==undefined?"":fac.cliente.catastro;
        cliente.medidor = fac.cliente.medidor==undefined?"":fac.cliente.medidor;
        cliente.fecha = fac.cliente.fecha;
        cliente.categoria = fac.cliente.categoria==undefined?"":fac.cliente.categoria;
        cliente.circuito = fac.cliente.circuito==undefined?"":fac.cliente.circuito;
        cliente.actividad = fac.cliente.actividad==undefined?"":fac.cliente.actividad;
        cliente.ventanilla = fac.cabecera.ventanilla;

        Factura.imprimir(factura, cliente,duplicado).then((res) => {
            this.finalizarImpresion(res);
        })
    }
}